@if (agentCreateMemberModel) {
<form [formGroup]="createMemberForm">
  <div class="content-container">
    <div class="mb-2 title d-inline-flex w-100">
      <mwp-text-translate text="Personal Information" jsonKey="personalInformation" />
    </div>
    <div class="d-flex flex-wrap">
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="First Name" nameForControl="firstName" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Middle Name" nameForControl="middleName" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Last Name" nameForControl="lastName" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="SSN" nameForControl="ssnDecrypted" type="number" [maskType]="maskType.social" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-datepicker [form]="createMemberForm" labelName="Date Of Birth" nameForControl="dateOfBirth" [autoTranslate]="true"></mwp-datepicker>
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown-enum [form]="createMemberForm" labelName="Gender" nameForControl="gender" [dataEnum]="genders" [autoTranslate]="true"></mwp-dropdown-enum>
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Address 1" nameForControl="homeAddressLine1" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Address 2" nameForControl="homeAddressLine2" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="City" nameForControl="homeCity" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown-enum [form]="createMemberForm" labelName="State" nameForControl="homeState" [dataEnum]="usStates" [autoTranslate]="true"></mwp-dropdown-enum>
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Zip Code" nameForControl="homeZipCode" [maskType]="maskType.zipCode" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Home Phone" nameForControl="homePhone" [maskType]="maskType.phone" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Cell Phone" nameForControl="cellPhone" [maskType]="maskType.phone" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Home Email" nameForControl="homeEmail" type="email" />
      </div>
    </div>
  </div>
  <div class="content-container">
    <div class="mb-2 title d-inline-flex w-100">
      <mwp-text-translate text="Employment Information" jsonKey="employmentInformation" />
    </div>
    <div class="d-flex flex-wrap">
      @if (agentCreateMemberModel.showErid) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="ERID" nameForControl="erid" />
      </div>
      }
      @if (agentCreateMemberModel.showPayrollNumber) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Payroll Number" nameForControl="payrollNumber" />
      </div>
      }
      @if (agentCreateMemberModel.availableEmploymentStatuses.length > 0) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" labelName="Employment Status" nameForControl="employmentStatus" [data]="agentCreateMemberModel.availableEmploymentStatuses" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      <div class="w-20 p-3 mb-3">
        <mwp-datepicker [form]="createMemberForm" labelName="Date of Hire" nameForControl="dateOfHire" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Work Hours" type="number" nameForControl="workHours" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Work Phone" nameForControl="workPhone" [maskType]="maskType.phone" />
      </div>
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Work Email" nameForControl="workEmail" type="email" />
      </div>
      @if (agentCreateMemberModel.showDivision) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayDivisionCaption" nameForControl="division" [data]="agentCreateMemberModel.availableDivision" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showCompanyLocation) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayCompanyLocationCaption" nameForControl="companyLocation" [data]="agentCreateMemberModel.availableCompanyLocations" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showDepartment) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayDepartmentCaption" nameForControl="department" [data]="agentCreateMemberModel.availableDepartment" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showPosition) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayPositionCaption" nameForControl="position" [data]="agentCreateMemberModel.availablePosition" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showSalary1) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Salary 1" nameForControl="salary1" [maskType]="maskType.currency" />
      </div>
      }
      @if (agentCreateMemberModel.showSalary1) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" labelName="Salary 1" nameForControl="salary1Frequency" [data]="salaryFrequencies" [isListItemArray]="true">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showSalary2) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Salary 2" nameForControl="salary2" [maskType]="maskType.currency" />
      </div>
      }
      @if (agentCreateMemberModel.showSalary2) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" labelName="Salary 2" nameForControl="salary2Frequency" [data]="salaryFrequencies" [isListItemArray]="true">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showSalary3) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" labelName="Salary 3" nameForControl="salary3" [maskType]="maskType.currency" />
      </div>
      }
      @if (agentCreateMemberModel.showSalary3) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" labelName="Salary 3" nameForControl="salary3Frequency" [data]="salaryFrequencies" [isListItemArray]="true">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showEEClass1) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayEEClass1Caption" nameForControl="eEClass1" [data]="agentCreateMemberModel.availableEEClass1" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showEEClass2) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayEEClass2Caption" nameForControl="eEClass2" [data]="agentCreateMemberModel.availableEEClass2" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showEEClass3) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayEEClass3Caption" nameForControl="eEClass3" [data]="agentCreateMemberModel.availableEEClass3" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showEEClass4) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayEEClass4Caption" nameForControl="eEClass4" [data]="agentCreateMemberModel.availableEEClass4" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showEEClass5) {
      <div class="w-20 p-3 mb-3">
        <mwp-dropdown [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayEEClass5Caption" nameForControl="eEClass5" [data]="agentCreateMemberModel.availableEEClass5" keyText="name" keyValue="id">
        </mwp-dropdown>
      </div>
      }
      @if (agentCreateMemberModel.showUdf1) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayUDF1Caption" nameForControl="udf1" [autoTranslate]="false" />
      </div>
      }
      @if (agentCreateMemberModel.showUdf2) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayUDF2Caption" nameForControl="udf2" [autoTranslate]="false" />
      </div>
      }
      @if (agentCreateMemberModel.showUdf3) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayUDF3Caption" nameForControl="udf3" [autoTranslate]="false" />
      </div>
      }
      @if (agentCreateMemberModel.showUdf4) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayUDF4Caption" nameForControl="udf4" [autoTranslate]="false" />
      </div>
      }
      @if (agentCreateMemberModel.showUdf5) {
      <div class="w-20 p-3 mb-3">
        <mwp-input [form]="createMemberForm" [labelName]="agentCreateMemberModel.displayUDF5Caption" nameForControl="udf5" [autoTranslate]="false" />
      </div>
      }
    </div>
  </div>
</form>
}
<div class="d-inline-flex w-100 justify-content-end p-3">
  <button class="mwp-button-save" [disabled]="!agentCreateMemberModel || !createMemberForm.valid" (click)="save()">
    <mwp-text-translate text="Create Member" jsonKey="createMember" />
  </button>
</div>